import React from 'react';
import Payout from './Payout';
import {DieselRoute} from 'epic-diesel-common/src/hocs';

class PayoutView extends React.Component {
    static propTypes = {};

    render() {
        return <Payout />;
    }
}

export default DieselRoute(PayoutView, {path: 'payout'});
